import { z } from 'zod';
import type { Zone as LogisticOperatorZone } from '@/pages/Business/pages/LogisticOperator/models';
import type { Zone as RoutingZone } from '../../../models';

const zoneTypeListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const zoneTypesListSchema = z.array(zoneTypeListItemSchema);

const logisticZoneSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    color: z.string().nullable().optional(),
    geojson: z.unknown(),
    zoneTypeId: z.string(),
    logisticOperatorId: z.string(),
    isPolygon: z.boolean().optional(),
    ZoneType: z
      .object({
        id: z.string(),
        name: z.string(),
      })
      .optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
    LogisticOperator: z.unknown().optional(),
  })
  .passthrough();

const zonesListSchema = z.array(logisticZoneSchema);

const routingZoneSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    color: z.string().nullable().optional(),
    geojson: z.unknown(),
    zoneTypeId: z.string(),
    logisticOperatorId: z.string(),
    isPolygon: z.boolean().optional(),
    zoneType: z
      .object({
        id: z.string(),
        name: z.string(),
      })
      .optional(),
  })
  .passthrough();

const zonesForRoutingResponseSchema = z.object({
  zones: z.array(routingZoneSchema),
});

export const safeParseZonesForRouting = (
  data: unknown
): RoutingZone[] => {
  if (data == null) {
    return [];
  }
  const parsed = zonesForRoutingResponseSchema.safeParse(data);
  if (!parsed.success) {
    return [];
  }
  return parsed.data.zones as RoutingZone[];
};

export const safeParseZoneTypes = (
  data: { items?: unknown[] } | null | undefined
): Array<{ id: string; name: string }> => {
  if (data?.items == null) {
    return [];
  }
  const parsed = zoneTypesListSchema.safeParse(data.items);
  if (parsed.success) {
    return parsed.data;
  }
  return [];
};

export const safeParseLogisticOperatorZones = (
  items: unknown[] | undefined
): LogisticOperatorZone[] => {
  if (items == null) {
    return [];
  }
  const parsed = zonesListSchema.safeParse(items);
  if (parsed.success) {
    return parsed.data as LogisticOperatorZone[];
  }
  return [];
};
